//
// network-selector.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

/*  global angular: false, _: false*/

(function(){
    "use strict";

    angular.module('curalate').directive('networkSelector', ['EnvironmentService',
        function(EnvironmentService) {
            return {
                restrict: 'E',
                scope: {
                    // PossibleNetworks - An array of Strings with the names of networks which the selector will display
                    possibleNetworks: '=',
                    // EnabledNetworks - An array of Strings with the names of networks which will be enabled for selection
                    enabledNetworks: '=',
                    // Callback with one String param that will be called on selection. Param will be 'All' or the name of the network
                    callback: '&',
                    // Disables the network buttons.
                    disabled: '=ngDisabled'
                },
                replace: true,
                templateUrl: EnvironmentService.getTemplateRootDirectory() + 'network-selector.html',
                controller: ['$scope',
                    function($scope) {
                        $scope.model = {
                            currentNetwork: 'All'
                        };

                        $scope.model.selectNetwork = function(network) {
                            if (!$scope.model.isEnabledNetwork(network) && network !== 'All') {
                                return;
                            }

                            $scope.model.currentNetwork = network;
                            $scope.callback({network: network});
                        };

                        $scope.model.isCurrentNetwork = function(network) {
                            return $scope.model.currentNetwork === network;
                        };

                        $scope.model.isEnabledNetwork = function(network) {
                            return _($scope.enabledNetworks).contains(network);
                        };

                        if (_($scope.enabledNetworks).size() === 1) {
                            $scope.model.selectNetwork($scope.enabledNetworks[0]);
                        }
                    }
                ]
            };
        }
    ]);
})();
